import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Users from "../Pages/users";
import Dashboard from "../Pages/dashboard";
import Employees from "../Pages/employees";
import Roles from "../Pages/roles";
import Permissions from "../Pages/permissions";
import AdsApis from "../Pages/adsApis";
import Games from "../Pages/games";
import CharitableOrganizatons from "../Pages/charitableOrganizations";
import AddEmployee from "../Pages/employees/AddEmployee";
import Countries from "../Pages/countries";
import Provinces from "../Pages/provinces";
import Cities from "../Pages/cities";
import FAQs from "../Pages/faqs";
import BlogComments from "../Pages/blogs/blogComments";
import KbArticlesList from "../Pages/knowledgeBase/kbArticlesList";
import RolePermissions from "../Pages/rolePermissions";
import AddEditRolePermissions from "../Pages/rolePermissions/addEditRolePermissions";
import AddEditBlog from "../Pages/blogs/addEditBlog";
import Blogs from "../Pages/blogs";
import BlogCategoriesList from "../Pages/blogs/blogCategoriesList";
import AddEditKbArticle from "../Pages/knowledgeBase/addEditKbArticle";
import KbCategoriesList from "../Pages/knowledgeBase/kbCategoriesList";
import UserPermissions from "../Pages/userPermissions";
import AddEditUserPermissions from "../Pages/userPermissions/addEditUserPermissions";
import Profile from "../Pages/profile";
import Unauthorized from "../Components/unauthorized";
import LoadingSpinner from "../Components/spinner";
import { useNavigate } from "react-router-dom";
import NetworkError from "../Components/networkError";
import Reports from "../Pages/reports";
import Badge from "../Pages/badges";
import Achievement from "../Pages/achievements/index.jsx";
import Feedbacks from "../Pages/feedbacks";
import ContactUs from "../Pages/contact-us";
import UserProfile from "../Pages/users/UserProfile";
import EmployeeProfile from "../Pages/employees/EmployeeProfile";
import ViewGame from "../Pages/games/ViewGame";
import CharitableProfile from "../Pages/CharitableProfile/index";
import HomePage from "../Pages/customPages/Home";
import AboutPage from "../Pages/customPages/AboutUS";
import TermsPage from "../Pages/customPages/TermsPage";
import PrivacyPolicyPage from "../Pages/customPages/PrivacyPolicy";
import {
  getUserData,
  handleErrors,
  haveToLogin,
  removeUserData,
  removeUserToken,
} from "../services/dataManager";
import {
  fetchPermissionsGrantedToUser,
  verifyUserToken,
  fetchDashboardData,
} from "../services/axios/apiManager";
import { useAppContext } from "../services/context";
import AuthGuard from "../Components/guards/authGuard";
import PermissionGuard from "../Components/guards/permissionGuard";
import Authentication from "../Pages/Login";
import GameTags from "../Pages/tags";
import GameCategories from "../Pages/GameCategory";
import GameSubCategories from "../Pages/GameSubcategory";
import Banner from "../Pages/customPages/Banner";
import GameProvider from "../Pages/gameProviders";
import GameBugs from "../Pages/gameBugs";
import CustomiseablePages from "../Pages/customPages/customiseablePages";
import GameReviews from "../Pages/gameReviews";
import ManageNotifications from "../Pages/manageNotifications";
import VerifyEmailAddress from "../Pages/forgotPassword/verifyEmail";
import ResetPassword from "../Pages/forgotPassword/resetPassword";
import AdViewCount from "../Pages/reports/add-performance/Ad-view-count";
import AllReports from "../Pages/reports/Reports";
import ClickThroughRate from "../Pages/reports/add-performance/click-through-rate";
import FillRate from "../Pages/reports/add-performance/fill-rate";
import AdRevenuePerView from "../Pages/reports/add-performance/ad-revenue-per-view";
import AdViewsPerUser from "../Pages/reports/user-engagement/ad-views-per-user";
import SessionLengthvsAdViews from "../Pages/reports/user-engagement/Session-Length.vs.Ad-Views";
import RetentionAdFrequency from "../Pages/reports/user-engagement/retention-ad-frequency";
import TopUsersByAdViews from "../Pages/reports/user-engagement/top-users-by-ad-views";
import TopGamesByAdViews from "../Pages/reports/game-level/top-games-by-ad-views";
import AdRevenuePerGame from "../Pages/reports/game-level/ad-revenue-per-game";
import AdPlacementPerformance from "../Pages/reports/game-level/ad-placement-performance";
import PeakAdViewTimes from "../Pages/reports/time-based/peak-ad-view-times";
import SeasonalTrends from "../Pages/reports/time-based/seasonal-trends";
import AdRevenueByCountryRegion from "../Pages/reports/geographic-demographic/ad-revenue-by-country-region";
import UserDemographics from "../Pages/reports/geographic-demographic/user-demographics";
import RevenueByAdNetwork from "../Pages/reports/ad-network-performance/revenue-by-ad-network";
import FallbackPerformance from "../Pages/reports/ad-network-performance/fallback-performance";
import AdFormatComparison from "../Pages/reports/ab-testing/AdFormatComparison";
import UserFrequencyCappingImpact from "../Pages/reports/ab-testing/UserFrequencyCappingImpact";
import SuspiciousActivityAlerts from "../Pages/reports/fraud-invalid-traffic/suspicious-activity-alerts";
import AdBlockingDetection from "../Pages/reports/fraud-invalid-traffic/AdBlockingDetection";
import AdSkippingCancellationRate from "../Pages/reports/user-feedback-ad-experience/ad-skipping-cancellation-rate";
import UserComplaintsSurveys from "../Pages/reports/user-feedback-ad-experience/user-complaints-surveys";
import Notifications from "../Components/notifications";
import AdsUnits from "../Pages/adsApis/adUnits";
import AdsNetworkStats from "../Pages/reports/ad-network-performance/ads-network-stats";
import SEOPages from "../Pages/seo";
import Home_Page from "../Pages/homePage";
import AddEditSection from "../Pages/homePage/addEditSection";
import ReviewSections from "../Pages/homePage/reviewSections";
import Home_Banner from "../Pages/homeBanners";
import AddEditBanner from "../Pages/homeBanners/addEditBanner";
import ReviewBanner from "../Pages/homeBanners/reviewBanner";

const AppRoutes = () => {
  const navigate = useNavigate();
  const { setState } = useAppContext();

  const [loading, setLoading] = useState(true);

  const checkToken = async () => {
    try {
      const res = await verifyUserToken();
      if (res?.status === 200) {
        await getPermissions();
      } else {
        await removeUserData();
        await removeUserToken();
        // navigate("/login");
      }
    } catch (error) {
      console.log("Error on checking token : ", error);
      // navigate("/login");
    } finally {
      setLoading(false);
    }
  };
  const getPermissions = async () => {
    try {
      const userData = await getUserData();
      if (userData?.id && userData?.role_id) {
        const perms = await fetchPermissionsGrantedToUser(
          userData.id,
          userData.role_id,
        );
        if (perms?.data?.success && perms?.data?.data) {
          setState((prev) => ({ ...prev, permissions: perms.data.data }));
        } else {
          await handleErrors(perms, navigate, true);
        }
      } else {
        await haveToLogin(navigate);
      }
    } catch (error) {
      console.log("Error From App Routes : ", error);
    }
  };
  const getDashBoardData = async () => {
    const res = await fetchDashboardData();
    if (res?.data?.success && res?.data?.data) {
      setState((prev) => ({ ...prev, dashboardData: res.data.data }));
    } else {
      await handleErrors(res, navigate, true);
    }
  };
  useEffect(() => {
    // getPermissions();
    // getDashBoardData()
    checkToken();
  }, []);
  return (
    <>
      {loading ? (
        <div className="d-flex flex-grow-1 vh-100 justify-content-center align-items-center">
          <LoadingSpinner size="lg" />
        </div>
      ) : (
        <Routes>
          <Route
            path="/login"
            element={<Authentication navigate={navigate} />}
          />
          <Route
            path="/"
            element={
              <AuthGuard>
                <Dashboard navigate={navigate} />
              </AuthGuard>
            }
          />
          <Route
            path="/dashboard"
            element={
              <AuthGuard>
                <Dashboard navigate={navigate} />
              </AuthGuard>
            }
          />
          <Route
            path="/users"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Users:view">
                  <Users navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/employees"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Employees:view">
                  <Employees navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/role"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Roles:view">
                  <Roles navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/permissions"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Permissions:view">
                  <Permissions navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/AdsApi"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Ads_APIs:view">
                  <AdsApis navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/AdsApi/Ad-Unit/:id"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Ads_APIs:view">
                  <AdsUnits navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/GamingPlatformManagement"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Games:view">
                  <Games navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/game/details/:id"
            element={
              <AuthGuard>
                <Games navigate={navigate} />
              </AuthGuard>
            }
          />
          <Route
            path="/CharitableOrganization"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Charitable_Organizations:view">
                  <CharitableOrganizatons navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/AddEditEmployee/:tab/:id"
            element={
              <AuthGuard>
                <AddEmployee />
              </AuthGuard>
            }
          />
          <Route
            path="/AddEditEmployee/:tab"
            element={
              <AuthGuard>
                <AddEmployee />
              </AuthGuard>
            }
          />
          <Route
            path="/Country"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Countries:view">
                  <Countries navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/Province"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Provinces:view">
                  <Provinces navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/City"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Cities:view">
                  <Cities navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/FaqsManagement"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="FAQs:view">
                  <FAQs navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/BlogsManagement/categories"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Blogs:view">
                  <BlogCategoriesList />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/BlogsManagement"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Blogs:view">
                  <Blogs navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/BlogsManagement/add"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Blogs:create">
                  <AddEditBlog />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/BlogsManagement/edit/:id"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Blogs:update">
                  <AddEditBlog />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/BlogsManagement/comments/:id"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Blogs:update">
                  <BlogComments />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/KbManagement/categories"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Knowledgebase:view">
                  <KbCategoriesList />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/KbManagement"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Knowledgebase:view">
                  <KbArticlesList />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/KbManagement/add"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Knowledgebase:create">
                  <AddEditKbArticle />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/KbManagement/edit/:id"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Knowledgebase:update">
                  <AddEditKbArticle />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/rolePermissions"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Role_Permissions:view">
                  <RolePermissions navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/rolePermissions/edit"
            element={
              <AuthGuard>
                <AddEditRolePermissions navigate={navigate} />
              </AuthGuard>
            }
          />
          <Route
            path="/userPermissions"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="User_Permissions:view">
                  <UserPermissions navigate={navigate} />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/userPermissions/edit"
            element={
              <AuthGuard>
                <AddEditUserPermissions navigate={navigate} />
              </AuthGuard>
            }
          />
          <Route
            path="/AdminProfile"
            element={
              <AuthGuard>
                <Profile />
              </AuthGuard>
            }
          />
          <Route
            path="/reports"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Reports:view-insights">
                  <Reports />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/badges"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Badges:view">
                  <Badge />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/achievements"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Achievements:view">
                  <Achievement />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/trouble-tickets"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Feedbacks:view">
                  <Feedbacks />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/contactUs"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Contact_Us:view">
                  <ContactUs />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/EmployeeProfile/:id"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Employees:view">
                  <EmployeeProfile />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/ViewGame/:id"
            element={
              <AuthGuard>
                {/* <PermissionGuard requiredPermission="users:view"> */}
                <ViewGame />
                {/* </PermissionGuard> */}
              </AuthGuard>
            }
          />
          <Route
            path="/editGame/:id"
            element={
              <AuthGuard>
                {/* <PermissionGuard requiredPermission="users:view"> */}
                <ViewGame />
                {/* </PermissionGuard> */}
              </AuthGuard>
            }
          />
          <Route
            path="/addGame"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Games:create">
                  <ViewGame />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/UserProfile/:id"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Users:view">
                  <UserProfile />
                </PermissionGuard>
              </AuthGuard>
            }
          />

          <Route
            path="/HomePage"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Custom_Pages:view">
                  <HomePage />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/AboutPage"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Custom_Pages:view">
                  <AboutPage />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/TermsPage"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Custom_Pages:view">
                  <TermsPage />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/PrivacyPolicyPage"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Custom_Pages:view">
                  <PrivacyPolicyPage />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/customPages"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Custom_Pages:view">
                  <CustomiseablePages />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/seo-management"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Pages_Metadata:view">
                  <SEOPages />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route
            path="/CharitableOrganization/details/:id"
            element={<CharitableProfile />}
          />
          <Route
            path="/CharitableOrganization/add"
            element={<CharitableProfile />}
          />
          <Route
            path="/tags"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Tags:view">
                  <GameTags />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          <Route
            path="/gamecategory"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Game_Category:view">
                  <GameCategories />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          <Route
            path="/GameSubcategory"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Game_Sub_Category:view">
                  <GameSubCategories />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          <Route
            path="/home-banner"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Home_Banners:view">
                  <Home_Banner />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          <Route
            path="/add-edit-home-banner/:id"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Home_Banners:update">
                  <AddEditBanner />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          <Route
            path="/add-edit-home-banner"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Home_Banners:create">
                  <AddEditBanner />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          <Route
            path="/review-home-banner/:bannerId"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Home_Banners:view">
                  <ReviewBanner />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          <Route
            path="/review-home-banner"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Home_Banners:view">
                  <ReviewBanner />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          {/* <Route
            path="/Banner"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Manage_Custom_Pages:view">
                  <Banner />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          /> */}
          <Route
            path="/providers"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Game_Providers:view">
                  <GameProvider />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          <Route
            path="/bugs"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Bug_Reports:view">
                  <GameBugs />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          <Route
            path="/game-reviews"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Game_Reviews:view">
                  <GameReviews />
                </PermissionGuard>
                /
              </AuthGuard>
            }
          />
          <Route
            path="/manage-notifications"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Notifications:view">
                  <ManageNotifications />
                </PermissionGuard>
              </AuthGuard>
            }
          />
          <Route path="/forgot-password" element={<VerifyEmailAddress />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/network-error" element={<NetworkError />} />

          {/* Reports */}

          <Route
            path="/ad-view-count"
            element={
              <AuthGuard>
                <AdViewCount />
              </AuthGuard>
            }
          />

          <Route
            path="/all-reports"
            element={
              <AuthGuard>
                <PermissionGuard requiredPermission="Reports:view">
                  <AllReports />
                </PermissionGuard>
              </AuthGuard>
            }
          />

          <Route
            path="/click-through-rate"
            element={
              <AuthGuard>
                <ClickThroughRate />
              </AuthGuard>
            }
          />

          <Route
            path="/fill-rate"
            element={
              <AuthGuard>
                <FillRate />
              </AuthGuard>
            }
          />

          <Route
            path="/ad-revenue-per-view"
            element={
              <AuthGuard>
                <AdRevenuePerView />
              </AuthGuard>
            }
          />

          <Route
            path="/ad-views-per-user"
            element={
              <AuthGuard>
                <AdViewsPerUser />
              </AuthGuard>
            }
          />

          <Route
            path="/session-length-vs-ad-views"
            element={
              <AuthGuard>
                <SessionLengthvsAdViews />
              </AuthGuard>
            }
          />

          <Route
            path="/retention-ad-frequency"
            element={
              <AuthGuard>
                <RetentionAdFrequency />
              </AuthGuard>
            }
          />

          <Route
            path="/top-users-by-ad-views"
            element={
              <AuthGuard>
                <TopUsersByAdViews />
              </AuthGuard>
            }
          />

          <Route
            path="/top-games-by-ad-views"
            element={
              <AuthGuard>
                <TopGamesByAdViews />
              </AuthGuard>
            }
          />

          <Route
            path="/ad-revenue-per-game"
            element={
              <AuthGuard>
                <AdRevenuePerGame />
              </AuthGuard>
            }
          />

          <Route
            path="/ad-placement-performance"
            element={
              <AuthGuard>
                <AdPlacementPerformance />
              </AuthGuard>
            }
          />

          <Route
            path="/peak-ad-view-times"
            element={
              <AuthGuard>
                <PeakAdViewTimes />
              </AuthGuard>
            }
          />

          <Route
            path="/seasonal-trends"
            element={
              <AuthGuard>
                <SeasonalTrends />
              </AuthGuard>
            }
          />

          <Route
            path="/ad-revenue-by-country-region"
            element={
              <AuthGuard>
                <AdRevenueByCountryRegion />
              </AuthGuard>
            }
          />

          <Route
            path="/user-demographics"
            element={
              <AuthGuard>
                <UserDemographics />
              </AuthGuard>
            }
          />

          <Route
            path="/revenue-by-ad-network"
            element={
              <AuthGuard>
                <RevenueByAdNetwork />
              </AuthGuard>
            }
          />

          <Route
            path="/fallback-performance"
            element={
              <AuthGuard>
                <FallbackPerformance />
              </AuthGuard>
            }
          />

          <Route
            path="/ad-format-comparison"
            element={
              <AuthGuard>
                <AdFormatComparison />
              </AuthGuard>
            }
          />

          <Route
            path="/user-frequency-capping-impact"
            element={
              <AuthGuard>
                <UserFrequencyCappingImpact />
              </AuthGuard>
            }
          />

          <Route
            path="/suspicious-activity-alerts"
            element={
              <AuthGuard>
                <SuspiciousActivityAlerts />
              </AuthGuard>
            }
          />

          <Route
            path="/Ad-blocking-detection"
            element={
              <AuthGuard>
                <AdBlockingDetection />
              </AuthGuard>
            }
          />

          <Route
            path="/ad-skipping-cancellation-rate"
            element={
              <AuthGuard>
                <AdSkippingCancellationRate />
              </AuthGuard>
            }
          />

          <Route
            path="/user-complaints-surveys"
            element={
              <AuthGuard>
                <UserComplaintsSurveys />
              </AuthGuard>
            }
          />
          <Route
            path="/user-complaints-surveys"
            element={
              <AuthGuard>
                <UserComplaintsSurveys />
              </AuthGuard>
            }
          />
          <Route
            path="/ad-network-stats"
            element={
              <AuthGuard>
                <AdsNetworkStats />
              </AuthGuard>
            }
          />
          <Route
            path="/notifications"
            element={
              <AuthGuard>
                <Notifications />
              </AuthGuard>
            }
          />
          <Route
            path="/home-page"
            element={
              // <AuthGuard>
              //   <PermissionGuard requiredPermission="Ads_APIs:view">
              <Home_Page navigate={navigate} />
              //   </PermissionGuard>
              // </AuthGuard>
            }
          />
          <Route
            path="/add-edit-section"
            element={
              // <AuthGuard>
              //   <PermissionGuard requiredPermission="Ads_APIs:view">
              <AddEditSection navigate={navigate} />
              //   </PermissionGuard>
              // </AuthGuard>
            }
          />
          <Route
            path="/review-sections"
            element={
              // <AuthGuard>
              //   <PermissionGuard requiredPermission="Ads_APIs:view">
              <ReviewSections navigate={navigate} />
              //   </PermissionGuard>
              // </AuthGuard>
            }
          />
          <Route
            path="/review-sections/:secId"
            element={
              // <AuthGuard>
              //   <PermissionGuard requiredPermission="Ads_APIs:view">
              <ReviewSections navigate={navigate} />
              //   </PermissionGuard>
              // </AuthGuard>
            }
          />
        </Routes>
      )}
    </>
  );
};

export default AppRoutes;
